import { useQuery } from '@tanstack/react-query';
import { fetchStudentDashboard, fetchPracticeQuestions } from '../api/student';

export function useStudentDashboard(enabled: boolean) {
  return useQuery({
    queryKey: ['student', 'dashboard'],
    queryFn: fetchStudentDashboard,
    enabled,
  });
}

export function usePracticeQuestions(topicId: number, enabled: boolean) {
  return useQuery({
    queryKey: ['student', 'practice', topicId],
    queryFn: () => fetchPracticeQuestions(topicId),
    enabled: enabled && Boolean(topicId),
  });
}
